<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-03-27 18:03:28
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-03-27 18:04:18
 * @FilePath: \crm-product\found\views\cps\views\execute\customer_record_flow\form\data_synchronism.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import request from '@/found/utils/request';
import Form, { formCreate } from '@/found/components/form';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'dealers_record_flow_data_synchronism',
      buttonText: {
        submit: '确认',
      },
    };
  },

  methods: {
    // 设置rule
    setRule(v) {
      const item = v;
      return item;
    },
    // 表单渲染完成后调用
    formComplete() {},
    // 表单提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        request
          .get(
            '/cps-mobile/v1/consumerScanReportController/syncDateConsumerScanCode',
            formData,
          )
          .then((res) => {
            if (!res.success) return this.$message.error(res.message);
            this.$message.success('数据同步成功');
            this.$emit('onClose');
            this.$emit('onGetList');
          });
      }
    },
  },
};
</script>
